module.exports = __webpack_public_path__ + "slogan.jpg?69e7a5e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/slogan.jpg
 ** module id = 66
 ** module chunks = 0
 **/